import { nextTick } from 'vue'
import { EVENTS } from '@/shared/constants/commons'
import Events from '@/events/events'
import { notifyDevs } from '@/shared/errors/notifyDevs'
import { warmupLocation } from '@/project/components/map/uitls/helpers'

async function boot() {
  await nextTick()
  Events.dispatch(EVENTS.APP_READY)
  document.addEventListener('DOMContentLoaded', () => {
    const hostname = window.location.hostname
    if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
      notifyDevs('👋 Un utilisateur a ouvert la plateforme')
    }
  })

  // Préchauffage GPS en arrière-plan : la position sera disponible immédiatement
  // quand la carte se monte (Stale-While-Revalidate)
  warmupLocation()
}

export default boot
